/*                                      */

/**
 *
 *
 */
export const VERSION = '5.36.13';
export const PUBLIC_VERSION = '5';
